import { CustomIntegration } from '/hooks/useCustomIntegrations';

interface Props {
  integration: CustomIntegration;
}

export const MainIntegration: React.FC<Props> = ({ integration }) => {
  return (
    <>
      <iframe
        allow={integration.allow}
        // @ts-ignore
        csp={integration.csp}
        loading={integration.loading ?? 'lazy'}
        id={`iframe-integration-${integration.id}`}
        name={integration.name}
        referrerPolicy={integration.referrerPolicy}
        sandbox={integration.sandbox}
        src={integration.src}
        srcDoc={integration.srcdoc}
      />
      <style jsx>{`
        iframe {
          border: none;
          height: 100%;
          width: 100%;
        }
      `}</style>
    </>
  );
};
